<template>
  <form
    :action="route"
    class="terms-and-conditions-form"
    role="form"
    method="POST"
  >
    <div
      class="column is-12 terms-and-conditions-body"
      v-html="page.body"
    ></div>
    <div class="column is-12">
      <div
        :class="form.errors.has('terms_and_conditions') ? 'has-error' : ''"
        class="field terms-and-conditions-input"
      >
        <p class="control">
          <label class="checkbox">
            <input
              v-model="form.terms_and_conditions"
              type="checkbox"
              name="terms_and_conditions"
            />
            <span v-html="$t('registration.gdpr.terms_and_conditions')" />
          </label>
          <span
            v-if="form.errors.has('terms_and_conditions')"
            class="help is-danger"
            v-html="form.errors.get('terms_and_conditions')"
          />
        </p>

        <button
          type="submit"
          class="button is-primary is-medium is-outlined ml-1"
          @click.prevent="save()"
        >
          {{ $t('registration.gdpr.submit') }}
        </button>
      </div>
    </div>
  </form>
</template>

<style lang="scss">
.terms-and-conditions {
  &-form {
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.2);
  }

  &-body {
    max-height: 500px;
    overflow-y: auto;
  }

  &-input {
    background-color: #f5f5f5;
    margin: 10px;
    padding: 15px 10px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;

    label > span {
      font-size: 22px;
    }

    input {
      margin-right: 10px;
    }

    .checkbox {
      margin-left: 20px;
    }
  }
  .ql-align-justify {
    text-align: justify;
  }
}
</style>

<script>
import Form from '../../helpers/Form/Form';

export default {
  name: 'TermsAndConditions',

  props: {
    route: { type: String, required: true },
    page: { type: Object, required: true },
    redirect: { type: String, default: '/' }
  },

  data() {
    return {
      form: new Form({
        terms_and_conditions: null
      })
    };
  },

  methods: {
    save() {
      const loader = this.$loading.show();
      this.form
        .post(this.route)
        .then(() => {
          location.href = this.redirect ? this.redirect : '/profile';
        })
        .catch(() => {
          error(this.$t('registration.flash_error'));
          loader.hide();
        });
    }
  }
};
</script>
